export const getApiBaseUrl = (): string => {
  const apiUrl = process.env.REACT_APP_API_URL;
  if (!apiUrl || !/^https?:\/\//.test(apiUrl)) {
    throw new Error('REACT_APP_API_URL is not defined or invalid');
  }
  return apiUrl.replace(/\/$/, '');
};

export const API_URL = getApiBaseUrl();
